import { displayLoader, hideLoader } from './windows';

export async function serviceCall(url, method, token, display403Error, displayGenericError, data = null, options = {}){
    const { displayAndHideLoader = true, customErrorHandler = null } = options
    if(displayAndHideLoader){
    	displayLoader()
    }

    const headers = {token: token}
    if(data){
        headers["Content-Type"] = "application/json"
    }

	return await fetch(url, {
    method: method,
    headers: headers,
    body: data
  })
    .then(async (res) => {
        if(displayAndHideLoader){
        	hideLoader()
        }

    	if(res.status === 403){
    		display403Error()
    		return "error"
    	}
    	else if(res.status !== 200){
            let errorResponse = null

            try {
                errorResponse = await res.json()
            } catch (error) {
                console.error("No se pudo leer la respuesta de error", error)
            }

            const handledError = customErrorHandler && customErrorHandler(errorResponse) === true

            if(!handledError){
                displayGenericError(res.status)
            }

    		return "error"
    	}

    	return res.json()
    })
}
